// extracted by mini-css-extract-plugin
module.exports = {"DefaultAvatar":"UserAvatar_DefaultAvatar__mzpr8"};